import styles from './GiftBottomSection.module.css'
import Spacer from "../../atoms/Spacer/Spacer"
import { Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import SubscriptionGiftConfirmationDialog from '../../organisms/SubscriptionGiftConfirmationDialog/SubscriptionGiftConfirmationDialog'
import { useContext, useState } from 'react'
import { AppContext } from '../../../stores/App/AppStore'
import { Route } from '../../../router'

const GiftBottomSection = () => {
    const [isFAQDialogOpen, setIsFAQDialogOpen] = useState(false)
    const [isTNCDialogOpen, setIsTNCDialogOpen] = useState(false)
    const { state: appState } = useContext(AppContext)

    return <>
        <Typography variant="h6" className={styles.moreInfoText}>
            For more information about NTUC Starter Membership click{` `}
            <Link to={Route.HOME} target="_blank" rel="noopener noreferrer" style={{ color: `#AB12DF`, textDecoration: `underline` }}>
                here
            </Link>
            .
        </Typography>
        <Spacer height={24}/>
        <Typography className={styles.linkText} onClick={()=> setIsFAQDialogOpen(true)}>Frequently Asked Questions</Typography>
        <Typography className={styles.linkText} onClick={()=> setIsTNCDialogOpen(true)}>Terms & Conditions</Typography>
        <Spacer height={20}/>
        <SubscriptionGiftConfirmationDialog
            faqText={appState.pages.giftSubscriptionLandingPage.faq ?? ``}
            isFAQDialogOpen={isFAQDialogOpen}
            onFAQDialogConfirm={setIsFAQDialogOpen}
            tncText={appState.pages.giftSubscriptionLandingPage.tnc ?? ``}
            isTNCDialogOpen={isTNCDialogOpen}
            onTNCDialogConfirm={setIsTNCDialogOpen}
        />
    </>

}

export default GiftBottomSection